module.exports = __webpack_public_path__ + "img/img-5.56c60672.jpg";